module.exports = __webpack_public_path__ + "img/Frente-36-02 open.9f428f6d.jpg";